import { useRef } from 'react'
import { SaFStyleType } from './SaF.types'
import { useResizeDetector } from 'react-resize-detector'

type UseSaFColumnWidthProps = {
  chartOuterContainer: HTMLDivElement | null
  columnsLength: number
  safTheme: SaFStyleType
}

export default function useSaFColumnWidth({
  chartOuterContainer,
  columnsLength,
  safTheme
}: UseSaFColumnWidthProps) {
  const targetRef = useRef<HTMLElement>()

  if (chartOuterContainer?.parentElement) {
    targetRef.current = chartOuterContainer.parentElement
  }

  const { width: chartParentWidth = 0 } = useResizeDetector({
    refreshMode: 'debounce',
    refreshRate: 500,
    targetRef
  })

  const columnWidth = Math.max(
    chartParentWidth / columnsLength,
    safTheme.chartColumnMinimumWidth
  )

  return columnWidth
}
